module.exports = __webpack_public_path__ + "static/media/logo106.0b843fda.png";